export default __webpack_public_path__ + "static/media/image2.d182b68e.jpg";